import type { TenantId } from '../../types/app';
import { optionalConfigInfoByTenant } from './tenant-configs.constants';

export const getCreateTenantConfigInfo = (tenantId: TenantId) =>
  optionalConfigInfoByTenant[tenantId];
